import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  constructor() { }

  setStorage(key: string, value: any): void {
    localStorage.setItem(key, value);
  }

  getStorage(key: string): any {
    return localStorage.getItem(key);
  }
}
